import type { ReactNode } from "react";
import type { StateTone } from "@shared-core/domain/object-ui/contract";
import { Badge } from "../primitives/badge";

const VARIANT_BY_TONE = {
  neutral: "neutral",
  in_progress: "info",
  attention: "warning",
  done: "success",
  stopped: "error",
} as const satisfies Record<StateTone, string>;

/**
 * A record's state as a badge, coloured by the tone its object declares for it (concepts.yaml `state_tones`). The
 * colour backs up the word and never replaces it: a person who cannot tell the colours apart still reads the state.
 */
export function StateBadge({
  tone,
  children,
}: {
  tone: StateTone;
  children: ReactNode;
}) {
  return (
    <Badge variant={VARIANT_BY_TONE[tone]} data-tone={tone}>
      {children}
    </Badge>
  );
}
